module.exports = __webpack_public_path__ + "img/req_cus_hui.f18f6a8a.png";